// property
export const PROPERTY_LIST = "PROPERTY_LIST";
export const PROPERTY_DETAIL = "PROPERTY_DETAIL";
export const GET_LANGUAGES = "GET_LANGUAGES";
export const LOGIN = "LOGIN";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const USER_LOADED = "USER_LOADED";
export const USER_FAIL = "USER_FAIL";
export const REGISTER_OTP = "REGISTER_OTP";
export const CHNAGE_PASSWORD = "CHANGE_PASSWORD";
export const TESTIMONIAL_LIST = "TESTIMONIAL_LIST";
export const PARTNER_LIST = "PARTNER_LIST";
export const APPLY_PROPERTY = "APPLY_PROPERTY";
export const LIKE_PROPERTY = "LIKE_PROPERTY";
export const HIDDEN_PROPERTY = "HIDDEN_PROPERTY";
export const FAVOURITE_LIST = "FAVOURITE_LIST";
export const REPORT_PROPERTY = "REPORT_PROPERTY";
export const PROPERTY_WATCH = "PROPERTY_WATCH";
export const TENANT_LIST = "TENANT_LIST";

// Chats
export const GET_ALL_CHAT = "GET_ALL_CHAT";
export const GET_FIREBASE_MSG = "GET_FIREBASE_MSG";
export const GET_LAST_MSG = "GET_LAST_MSG";
export const GET_CMS_CONTENT = "GET_CMS_CONTENT";
export const LOAD_CMS_CONTENT = "LOAD_CMS_CONTENT";
export const GET_LABELS = "GET_LABELS";
export const GET_LABELS_Name = "GET_LABELS_Name";

// favourite properties
export const GET_ALL_FAVOURITE_PROPERTIES = "GET_ALL_FAVOURITE_PROPERTIES";

// hidden properties
export const GET_ALL_HIDDEN_PROPERTIES = "GET_ALL_HIDDEN_PROPERTIES";

// applied properties
export const GET_ALL_APPLIED_PROPERTIES = "GET_ALL_APPLIED_PROPERTIES";

//user_wish_list
export const GET_ALL_WISHLISH = "GET_ALL_WISHLISH";
export const GET_WISHLISTBYID = "GET_WISHLISTBYID";

// subscription
export const GET_ALL_SUBSCRIPTION = "GET_ALL_SUBSCRIPTION";
export const GET_RUNNING_SUBSCRIPTION = "GET_RUNNING_SUBSCRIPTION";
export const GET_SUBSCRIPTION_HISTORY = "GET_SUBSCRIPTION_HISTORY";
export const GET_DASHBOARD_DETAILS = "GET_DASHBOARD_DETAILS";

export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";

export const FORGOT_PASSWORD_CHECK_OTP = "FORGOT_PASSWORD_CHECK_OTP";
export const CHANGED_PASSWORD = "CHANGED_PASSWORD";

export const ACTIVE_PROPERTY_LIST = "ACTIVE_PROPERTY_LIST";

export const GET_QUESTION_ANSWER = "GET_QUESTION_ANSWER";
export const PROPERTY_ADS = "PROPERTY_ADS";

export const RESET_PASSWORD_SENT_OTP = "RESET_PASSWORD_SENT_OTP";
export const GET_ALL_CARDS = "GET_ALL_CARDS";

export const GET_ALL_DASBOARD_CHAT = "GET_ALL_DASBOARD_CHAT";
export const GET_ALL_REPORTED_PROPERTIES ="GET_ALL_REPORTED_PROPERTIES";
export const GET_TENANT_TABLE='GET_TENANT_TABLE';
export const RENTER_LIST_DETAILS="RENTER_LIST_DETAILS";

export const SET_STEP="SET_STEP";
export const SET_IS_SUBSCRIBING ="SET_IS_SUBSCRIBING"

export const VERIFY_EMAIL ="VERIFY_EMAIL"